document.addEventListener("DOMContentLoaded", () => {
  const vupButtons = document.querySelectorAll('.vup-variant-btn');
  const priceEl = document.getElementById('vup-price');
  const buyBtn = document.getElementById('vup-buy-btn');

  vupButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      vupButtons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      // Cambiar precio dinámico
      priceEl.innerHTML = btn.dataset.price;

      // Cambiar URL del botón
      buyBtn.href = "/cart/add?id=" + btn.dataset.id;
    });
  });

  // marcar primera variante
  if (vupButtons.length > 0) {
    vupButtons[0].classList.add('active');
  }
});